import { H4 } from 'components/headings';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { FC } from 'react';
import { ReactComponent as CatastrophicWarning } from '../../assets/images/fire-danger-ratings/fire-danger-ratings-catastrophic.svg';
import { ReactComponent as ExtremeWarning } from '../../assets/images/fire-danger-ratings/fire-danger-ratings-extreme.svg';
import { ReactComponent as HighWarning } from '../../assets/images/fire-danger-ratings/fire-danger-ratings-high.svg';
import { ReactComponent as ModerateWarning } from '../../assets/images/fire-danger-ratings/fire-danger-ratings-moderate.svg';
import { ReactComponent as NoRatingWarning } from '../../assets/images/fire-danger-ratings/fire-danger-ratings-no-rating.svg';

import Carousel from '../carousel';
import { Text } from '../ui/text';
import {
  AllClearTitleText,
  AllWarnings,
  FireDangerSlider,
  IconWrapper,
  SlideCentred,
  TitleText,
} from './fire-danger-carousel.styles';

const FireDangerCarousel: FC = () => {
  return (
    <Carousel numberOfSlides={6}>
      <FireDangerSlider>
        <SlideCentred index={0}>
          <IconWrapper>
            <AllWarnings />
          </IconWrapper>

          <H4>Fire Danger Ratings</H4>
          <Text>
            The Fire Danger Rating System has four levels. Each level tells you
            how dangerous a bushfire could be if one starts and comes with clear
            actions to take.
            <br />
            <br />
            Check your local Fire Danger Ratings daily at&nbsp;
            <a
              href='https://www.emergency.wa.gov.au/#firedangerratings'
              target='_blank'
              rel='noreferrer'
            >
              emergency.wa.gov.au.
            </a>
          </Text>
        </SlideCentred>

        <SlideCentred index={1}>
          <IconWrapper>
            <ModerateWarning />
          </IconWrapper>

          <TitleText backgroundColor='moderate'>MODERATE</TitleText>
          <H4>Plan and prepare</H4>
          <Text>
            Most fires can be controlled.
            <br />
            <br />
            Stay up to date and be alert for fires in your area.
          </Text>
        </SlideCentred>

        <SlideCentred index={2}>
          <IconWrapper>
            <HighWarning />
          </IconWrapper>

          <TitleText backgroundColor='high'>HIGH</TitleText>
          <H4>Be ready to act.</H4>
          <Text>
            Fires can be dangerous.
            <br />
            <br />
            Decide what you will do if a fire starts. Leave bushfire risk areas
            if necessary.
          </Text>
        </SlideCentred>

        <SlideCentred index={3}>
          <IconWrapper>
            <ExtremeWarning />
          </IconWrapper>

          <TitleText backgroundColor='extreme'>EXTREME</TitleText>
          <Text size='xLarge'>
            <strong>Take action now</strong> to protect your life and property.
          </Text>
          <Text>
            Fires will spread quickly and be extremely dangerous.
            <br />
            <br />
            Put your bushfire plan into action. If you and your property are not
            prepared to the highest level, plan to leave early.
          </Text>
        </SlideCentred>

        <SlideCentred index={4}>
          <IconWrapper>
            <CatastrophicWarning />
          </IconWrapper>
          <TitleText backgroundColor='catastrophic' textColor='white'>
            CATASTROPHIC
          </TitleText>
          <Text size='xLarge'>
            For your survival, <strong>leave bushfire risk areas.</strong>
          </Text>
          <Text>
            These are the most dangerous conditions for a fire. If a fire starts
            and takes hold, lives are likely to be lost. Homes cannot withstand
            fires in these conditions.
          </Text>
        </SlideCentred>

        <SlideCentred index={5}>
          <IconWrapper>
            <NoRatingWarning />
          </IconWrapper>
          <AllClearTitleText backgroundColor='white'>
            NO RATING
          </AllClearTitleText>
          <Text>
            A 'no rating' will be declared on days where bushfires are unlikely
            to spread in a dangerous or life-threatening way.
            <br />
            <br />
            Find out more about the&nbsp;
            <a
              href='https://mybushfireplan.wa.gov.au/FireDangerRatings'
              target='_blank'
              rel='noreferrer'
            >
              Fire Danger Rating System.
            </a>
          </Text>
        </SlideCentred>
      </FireDangerSlider>
    </Carousel>
  );
};

export default FireDangerCarousel;
